import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import { getAllotmentLetterData } from "../../Services/AllAllotments";
import { getTemplateForAllotment } from "../../Services/AllotmentLetterTemplate";
import { generateAllotmentLetterPDFBytes } from "./allotmentLetterPdfEngine";

const DynamicAllotmentLetter = ({ allotment, onPdfGenerated }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [parkingData, setParkingData] = useState(null);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (!allotment?.allotment_payment_id) return;
    (async () => {
      try {
        const [data, tmpl] = await Promise.all([
          getAllotmentLetterData(allotment.allotment_payment_id),
          getTemplateForAllotment(allotment.project_id, allotment.wing_id),
        ]);
        setParkingData(data);
        setTemplate(tmpl);
      } catch (err) {
        console.error("Error loading allotment letter data:", err);
      }
    })();
  }, [allotment]);

  useEffect(() => {
    if (!template) return;
    (async () => {
      try {
        const pdfBytes = await generateAllotmentLetterPDFBytes(template, parkingData, allotment);
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        setPdfUrl(URL.createObjectURL(blob));
        const base64 = btoa(
          new Uint8Array(pdfBytes).reduce((d, b) => d + String.fromCharCode(b), "")
        );
        onPdfGenerated?.(base64);
      } catch (err) {
        console.error("Error generating allotment letter PDF:", err);
      }
    })();
  }, [template, parkingData]);

  const uploadPdfToBucket = async (pdfBytes) => {
    const allotmentPaymentId = allotment?.allotmentPaymentId;
    const timestamp = Date.now();
    const fileName = `allotment-${allotmentPaymentId}_${timestamp}.pdf`;
    const filePath = `allotments/${fileName}`;
    const blob = new Blob([pdfBytes], { type: "application/pdf" });

    const { error: uploadError } = await supabase.storage
      .from("AllotmentLetter")
      .upload(filePath, blob, { contentType: "application/pdf", upsert: true });

    if (uploadError) throw uploadError;

    return `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}AllotmentLetter/${filePath}`;
  };

  const saveUrlToDb = async (pdfUrl) => {
    const allotmentPaymentId = allotment?.allotmentPaymentId;
    if (!allotmentPaymentId || !pdfUrl) return;

    const { data: existing } = await supabase
      .from("EsignAllotment")
      .select("*")
      .eq("allotmentPaymentId", allotmentPaymentId);

    if (!existing || existing.length === 0) {
      const { data, error } = await supabase
        .from("EsignAllotment")
        .insert([{ allotmentPaymentId, generatedAllotmentUrl: pdfUrl }]);
      if (error) throw error;
      return data;
    } else {
      const { error } = await supabase
        .from("EsignAllotment")
        .update({ generatedAllotmentUrl: pdfUrl })
        .eq("allotmentPaymentId", allotmentPaymentId);
      if (error) throw error;
      return existing;
    }
  };

  // const handleEsignClick = async () => {
  //   setLoading(true);
  //   setError("");
  //   setSuccess("");
  //   try {
  //     const pdfBytes = await generateAllotmentLetterPDFBytes(template, parkingData, allotment);
  //     const uploadedUrl = await uploadPdfToBucket(pdfBytes);
  //     const savedRow = await saveUrlToDb(uploadedUrl);

  //     if (!savedRow?.[0]?.generatedAllotmentUrl && !savedRow?.generatedAllotmentUrl) {
  //       setError("PDF URL not saved in DB. Cannot proceed with e-sign.");
  //       return;
  //     }

  //     const payload = {
  //       callback_url: "https://example.com?state=test",
  //       configReason: "Contract1",
  //       fullName: parkingData?.name || "NA",
  //       mobileNumber: String(parkingData?.contactNumber || ""),
  //       userEmail: parkingData?.email || "fallback@example.com",
  //       allotmentPaymentId: allotment?.allotmentPaymentId,
  //     };

  //     const response = await fetch(
  //       `${process.env.REACT_APP_PAYMENT_LINK_URL}eSignInitialize`,
  //       { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }
  //     );
  //     const result = await response.json();

  //     if (result.success) {
  //       setSuccess("E-sign initialized successfully!");
  //       const { data, error: fetchErr } = await supabase
  //         .from("EsignAllotment")
  //         .select("eSignInitializedUrl")
  //         .eq("allotmentPaymentId", allotment?.allotmentPaymentId)
  //         .single();

  //       if (fetchErr || !data?.eSignInitializedUrl) {
  //         setError("E-sign initialized but failed to fetch URL from DB.");
  //         return;
  //       }
  //       window.open(data.eSignInitializedUrl, "_blank");
  //     } else {
  //       setError(result.message || "E-sign initialization failed.");
  //     }
  //   } catch (err) {
  //     console.error("E-sign error:", err);
  //     setError("Error during e-sign: " + err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  if (!template) {
    return (
      <p style={{ textAlign: "center", padding: "20px" }}>
        Loading allotment letter template...
      </p>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      {pdfUrl ? (
        <iframe
          src={pdfUrl + "#zoom=100&page=1"}
          title="Allotment Letter"
          style={{ width: "100%", height: "70vh", border: "none" }}
        />
      ) : (
        <p style={{ textAlign: "center", padding: "20px" }}>
          Generating Allotment Letter...
        </p>
      )}
    </div>
  );
};

export default DynamicAllotmentLetter;
